import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=71647de3&scoped=true"
import script from "./InputField.vue?vue&type=script&lang=js"
export * from "./InputField.vue?vue&type=script&lang=js"
import style0 from "./InputField.vue?vue&type=style&index=0&id=71647de3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71647de3",
  null
  
)

export default component.exports